



$(document).ready(function () {
  

  $('.add, .adds').click(function () {  
    setTimeout(function(){
      $('#cart').toggleClass('cart-active');
    }, 700);
    setTimeout(function(){
      updateCont()
    }, 1400);
  });


  $(document).on('click', '.ajax-cart__remove-button', function () {
    console.log("remove")
    updateCont()
  });

  
  $('.w-commerce-commercecartopenlink').click(function () {
    $('#cart').toggleClass('cart-active');
  });

  $('.w-commerce-commercecartcloselink').click(function () {
    $('#cart').toggleClass('cart-active');
  });

  
  function updateCont() {
    var cartItemCounter = document.querySelector('#count');
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
    }).done(function (data) {
      console.log(data);
      var newCount = data.item_count;
      cartItemCounter.innerText = newCount ;
    });
  }

  updateCont()


  $(document).on('click', '.radio div', function () {
    id = $(this).attr('alt');
    console.log(id);
    if (id == '0') {
      $(".porduct-image").attr('src',"//cirquedusoleil-fragrance.myshopify.com/cdn/shop/files/Bottle2_1000x1000.jpg?v=1743614941");
      console.log("0")
      $('#x1').css('display', 'none');
      $('#x0').css('display', 'initial');

      $(".radio ").removeClass("checked")
      $(this).parent().addClass("checked");

      $('#img_3, #img_4').css('display', 'none');
      $('#img_1, #img_2').css('display', 'flex');
      
      // $('#product > img:nth-child(3)').css('display', 'none');
      // $('#product > img:nth-child(2)').css('display', 'initial');
    } else if (id == '1') {
      console.log("1")
      $(".porduct-image").attr('src',"//cirquedusoleil-fragrance.myshopify.com/cdn/shop/files/travel2_1000x1000.jpg?v=1744304001");
      $('#x0').css('display', 'none');
      $('#x1').css('display', 'initial');

      $(".radio").removeClass("checked")
      $(this).parent().addClass("checked");
      
      $('#img_1, #img_2').css('display', 'none');
      $('#img_3, #img_4').css('display', 'flex');

      // $('#product > img:nth-child(3)').css('display', 'initial');
      // $('#product > img:nth-child(2)').css('display', 'none');
    }
  });

  $(document).on('click', '.image', function () {
    img = $(this).attr('src');
    console.log(img)
    $(".porduct-image").attr('src',img);
  })


  $('.drop1').on('click', function () {
    $(".child1").toggleClass("child1_active");
  });

  $('.drop2').on('click', function () {
    $(".child2").toggleClass("child2_active");
  });


  $(document).on('click', '.change', function () {
    id = $(this).attr('alt');
    console.log(id);
    if (id == '0') {
      $(".porduct-image").attr('src',"//cirquedusoleil-fragrance.myshopify.com/cdn/shop/files/Bottle2_1000x1000.jpg?v=1743614941");
      console.log("0")
      $('#x1').css('display', 'none');
      $('#x0').css('display', 'initial');

      $(".radio ").removeClass("checked")
      $("#ProductSelect-option-size-100ml").addClass("checked");

      $('#img_3, #img_4').css('display', 'none');
      $('#img_1, #img_2').css('display', 'flex');
      
      
      // $('#product > img:nth-child(3)').css('display', 'none');
      // $('#product > img:nth-child(2)').css('display', 'initial');
    } else if (id == '1') {
      console.log("1")
      $(".porduct-image").attr('src',"//cirquedusoleil-fragrance.myshopify.com/cdn/shop/files/travel2_1000x1000.jpg?v=1744304001");
      $('#x0').css('display', 'none');
      $('#x1').css('display', 'initial');

      $(".radio").removeClass("checked")
      $("#ProductSelect-option-size-10ml").addClass("checked");
      
      $('#img_1, #img_2').css('display', 'none');
      $('#img_3, #img_4').css('display', 'flex');
      // $('#product > img:nth-child(3)').css('display', 'initial');
      // $('#product > img:nth-child(2)').css('display', 'none');
    }
  })
  

})